// SFetch is wrapper for native browser fetch method.
// You can learn more from quip doc:
// https://silverfin.quip.com/S4iMANhPPvjY/Get-data-from-API-SFetch-library

import { camelizeJSON } from './common'
import { html } from './html'
import { json, jsonWithAlert } from './json'
import { postFormRedirect } from './post-form-redirect'
import { raw } from './raw'
import { withRetry } from './decorators/with-retry'

export default {
  raw,
  json,
  jsonWithAlert,
  html,
  camelizeJSON,
  postFormRedirect,
  withRetry,
}
